import * as React from 'react';
import { Colors } from '@prezi/dragon';
export function Avatar({
  size,
  username,
  email,
  firstName,
  lastName,
  className = ''
}) {
  const style = {
    fontFamily: 'RalewayBold, Helvetica, sans-serif',
    color: '#FFFFFF',
    width: size,
    height: size,
    borderRadius: size / 2,
    textAlign: 'center',
    fontSize: 0.44 * size,
    lineHeight: 1.05 * size + 'px',
    letterSpacing: 1,
    backgroundColor: calculateColor(username, email)
  };
  return React.createElement("div", {
    className: ('user-avatar ' + className).trim(),
    style: style
  }, getInitials(firstName, lastName, email));
}
const COLOR_PALETTE = [Colors.blueLight, '#4CD3D1', Colors.greenLight, '#E28BC0', Colors.orange, Colors.purple, Colors.magenta, Colors.gold];
const UNKNOWN_COLOR = Colors.gray4;

function calculateColor(username, email) {
  const _calculateColor = hashBase => COLOR_PALETTE[Math.abs(hash(hashBase)) % COLOR_PALETTE.length];

  if (email) {
    return _calculateColor(email);
  } else if (username) {
    return _calculateColor(username);
  } else {
    return UNKNOWN_COLOR;
  }
}

function hash(str) {
  if (str == null) {
    return 0;
  }

  let hashVal = 0;

  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    hashVal = (hashVal << 5) - hashVal + charCode;
    hashVal |= 0;
  }

  return hashVal;
}

function getInitials(firstName, lastName, email) {
  let initials = '';
  const firstNameInitials = firstName && firstName.charAt(0);
  const lastNameInitials = lastName && lastName.charAt(0);

  if (firstNameInitials || lastNameInitials) {
    initials = `${firstNameInitials}${lastNameInitials}`;
  } else if (email) {
    initials = email.charAt(0);
  }

  return initials.toLocaleUpperCase();
}